





































import { Component, Vue } from 'vue-property-decorator';
import {  mapActions, mapGetters } from 'vuex';
import { Gameplay, Difficultes, difficulty } from '@/model/grid';

@Component({
  computed: {
    ...mapGetters({
      show: 'setting/getDisplayStatus'
    })
  },
  methods: {
    ...mapActions('grid', ['setDifficulty']),
    ...mapActions('setting', ['toggleSetting']),
    ...mapActions('game', ['stopGame'])
  }
})
export default class Difficulty extends Vue {
  private difficulties = ['easy', 'medium', 'hard', 'custom'];
  private rows = this.$store.state.grid.rows;
  private columns = this.$store.state.grid.columns;
  private bombs = this.$store.state.grid.bombs;
  private difficulty = this.$store.state.grid.difficulty;
  
  setDifficulty!: (data: { difficultyType: Difficultes; updatedGameplay?: Gameplay}) => void;
  toggleSetting!: () => void;
  stopGame!: () => void;

  initSetDifficulty() {
    let updatedGameplay: Gameplay | undefined;
    const difficultyType = this.difficulty;

    if (difficultyType === 'custom') {
      updatedGameplay = {
        columns: this.columns,
        rows: this.rows,
        bombs: this.bombs
      }
    }
    
    this.setDifficulty({difficultyType, updatedGameplay});
    this.updateSettingFromStore();
    this.toggleSetting();
    this.stopGame();
  }

  updateSettingFromStore() {
    this.rows = this.$store.state.grid.rows;
    this.columns = this.$store.state.grid.columns;
    this.bombs = this.$store.state.grid.bombs;
  }

  updateDifficulty(difficultyType: Difficultes) {
    this.difficulty = difficultyType;
    if (difficultyType !== 'custom') {
      this.rows = difficulty[difficultyType].rows;
      this.columns = difficulty[difficultyType].columns;
      this.bombs = difficulty[difficultyType].bombs;
    }
  }
}
